/**
 * Flatter · Cart Manager (v2, 12 Ekim 2026)
 *
 * Sepet çekmecesinin tüm ekleme / çıkarma / adet işlemleri burada.
 * Önceki sürümdeki sorunlar ve bu sürümdeki karşılıkları:
 *  - Satırlar sıra numarasıyla (line: 1, 2, 3) değiştiriliyordu; bir satır silinince diğerlerinin numarası kayıyor,
 *    hızlı art arda silmede ikinci ürün sepette kalıyor ya da yanlış satır siliniyordu.
 *    → Her satır kendi anahtarıyla (item.key) değiştirilir; numara kayması etkilemez.
 *  - Aynı anda birden fazla istek gidiyordu. → Tüm sepet yazmaları tek sırada (kuyruk) çalışır.
 *  - Çekmece kapalıyken değişen sepet, çekmece açılınca eski içerikle görünebiliyordu.
 *    → Sepet her değiştiğinde çekmece içeriği (kapalı olsa da) Shopify'ın döndürdüğü güncel HTML ile yenilenir.
 *  - Adet kutusuna yazarken kutu ilk tuşta kilitleniyordu. → Kutu kilitlenmez; değer bırakılınca / Enter'da gönderilir.
 *
 * Dışarıya açık API (v4.js, ft-cart-fix, ft-complements, tema içi diğer betikler) korunur:
 *   window.CartManager.openDrawer() / closeDrawer() / fetchCart(force) / refresh() / isInitialized()
 *   getCart() / getItemCount() / getTotalPrice() / isEmpty() / addToCart(formData|items) / changeQuantity(keyOrLine, qty)
 *   clearCart() / addObserver(fn) / state.forceRefreshAfterUpdate (eski kod yazıyor; zararsız)
 * Olaylar (document): cart:fetched (detail = cart), cart:count-updated, cart:item-added, cart:quantity-changed,
 *   cart:upgraded, cart:drawer-opened, cart:drawer-closed, cart:external-update, cart:error, cart:gift-added,
 *   cart:gift-removed
 *
 * Hediye ürün (13 Ekim 2026): window.FT_GIFT (sections/cart-drawer.liquid → "Hediye ürün" ayarları). Sepet her
 * okunduğunda (_setCart) _checkGift çalışır: hediye satırı hariç ürünlerin tutarı eşiği geçiyorsa hediye 1 adet
 * eklenir (gizli "_ft_gift" özelliğiyle), geçmiyorsa ya da hediye sepette tek başına kaldıysa çıkarılır; birden
 * fazla hediye satırı / adedi 1'e indirilir. İşlem aynı kuyrukta, güncel sepete göre yapılır; döngü koruması var.
 * Ödemede bedava olması Shopify otomatik indirimiyle ("Hediye: 1.400 TL üzeri …") sağlanır.
 */
(function () {
  'use strict';
  if (window.CartManager && window.CartManager.__v2) return;

  var SECTION_ID = 'cart-drawer';
  var QTY_DEBOUNCE = 350;
  var EXTERNAL_DEBOUNCE = 120;
  var UPGRADE_ATTR = 'Sepet Yükseltme';
  var GIFT_PROP = '_ft_gift';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function url(path) {
    return root() + path.replace(/^\//, '');
  }
  function sleep(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function Manager() {
    this.__v2 = true;
    this.config = {
      FREE_SHIPPING_THRESHOLD: (window.CART_CONFIG && window.CART_CONFIG.FREE_SHIPPING_THRESHOLD) || 500000,
      DEBUG: false
    };
    this.state = {
      cart: null,
      isLoading: false,
      isInitialized: false,
      lastUpdate: 0,
      observers: new Set(),
      // eski betikler bu bayrakları yazıyor; v2'de sepet her değişimde zaten yenilendiği için etkisiz
      forceRefreshAfterUpdate: false,
      isQuantityUpdate: false,
      isAdding: false
    };
    this.elements = { drawer: null, overlay: null, body: null };

    this._fetch = window.fetch.bind(window); // kendi isteklerimiz: dinleyiciye takılmaz
    this._chain = Promise.resolve();
    this._pendingQty = {}; // key -> istenen adet (henüz gönderilmedi)
    this._qtyTimers = {};
    this._externalTimer = null;
    this._dirty = true;
    this._giftSyncing = false;
    this._giftRounds = 0;
    this._giftBlocked = false; // hediye eklenemedi (ör. stok bitti): bu sayfada tekrar denenmez

    this._onClick = this._onClick.bind(this);
    this._onChange = this._onChange.bind(this);
    this._onKeydown = this._onKeydown.bind(this);
    this._onSubmit = this._onSubmit.bind(this);

    var self = this;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { self._init(); });
    } else {
      this._init();
    }
  }

  var P = Manager.prototype;

  P.log = function () {
    if (this.config.DEBUG && window.console) console.log.apply(console, ['[CartManager]'].concat([].slice.call(arguments)));
  };

  /* ───────────── kurulum ───────────── */

  P._init = function () {
    this._bindElements();
    document.addEventListener('click', this._onClick);
    document.addEventListener('change', this._onChange);
    document.addEventListener('keydown', this._onKeydown);
    document.addEventListener('submit', this._onSubmit, true);
    this._interceptExternal();

    var self = this;
    this._enqueue(function () { return self._refresh(); })
      .catch(function () {})
      .then(function () {
        self.state.isInitialized = true;
      });
  };

  P._bindElements = function () {
    this.elements.drawer = document.getElementById('CartDrawer');
    this.elements.overlay = document.getElementById('CartDrawerOverlay');
    this.elements.body = document.getElementById('CartDrawerBody');
  };

  /* Başka betiklerin (v4.js, uygulamalar) sepet istekleri: bitince çekmece yenilenir. Kendi isteklerimiz this._fetch
     ile gittiği için buraya düşmez. */
  P._interceptExternal = function () {
    if (window.__CartInterceptPatched) return;
    window.__CartInterceptPatched = true;
    var self = this;
    var isCartWrite = function (u) { return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i.test(u || ''); };

    var original = window.fetch;
    window.fetch = function (resource, init) {
      var u = typeof resource === 'string' ? resource : (resource && resource.url) || '';
      var p = original.apply(this, arguments);
      if (isCartWrite(u)) {
        p.then(function (res) { if (res && res.ok) self._scheduleExternalRefresh(); }, function () {});
      }
      return p;
    };

    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, u) {
      this.__ftCartWrite = isCartWrite(String(u || ''));
      return open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__ftCartWrite) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) self._scheduleExternalRefresh();
        });
      }
      return send.apply(this, arguments);
    };
  };

  P._scheduleExternalRefresh = function () {
    var self = this;
    this._dirty = true;
    clearTimeout(this._externalTimer);
    this._externalTimer = setTimeout(function () {
      self._externalTimer = null;
      self._enqueue(function () { return self._refresh(); })
        .then(function () { self.notifyObservers('cart:external-update', self.state.cart); })
        .catch(function () {});
    }, EXTERNAL_DEBOUNCE);
  };

  /* Tüm sepet yazmaları sırayla: bir istek bitmeden diğeri başlamaz. */
  P._enqueue = function (task) {
    var run = this._chain.then(task, task);
    this._chain = run.catch(function () {});
    return run;
  };

  /* ───────────── ağ ───────────── */

  P._post = function (path, payload, withSections) {
    var body = Object.assign({}, payload || {});
    if (withSections) {
      body.sections = SECTION_ID;
      body.sections_url = root(); // bölüm bağlamı: ana sayfa (koleksiyon / ürün adresleri JSON isteğinde kendi verisini döndürüyor)
    }
    var self = this;
    var attempt = function (n) {
      return self._fetch(url(path), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        if (res.status === 429 && n < 2) return sleep(600 * (n + 1)).then(function () { return attempt(n + 1); });
        return res.text().then(function (text) {
          var data = null;
          try { data = text ? JSON.parse(text) : null; } catch (e) { data = null; }
          if (!res.ok) {
            var err = new Error((data && (data.description || data.message)) || ('Sepet isteği başarısız (' + res.status + ')'));
            err.status = res.status;
            err.data = data;
            throw err;
          }
          return data;
        });
      });
    };
    return attempt(0);
  };

  P._getCart = function () {
    return this._fetch(url('cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (res) {
        if (!res.ok) throw new Error('Sepet okunamadı (' + res.status + ')');
        return res.json();
      });
  };

  P._getSection = function () {
    // Not: koleksiyon / ürün adresine "Accept: application/json" ile gidilirse Shopify bölüm yerine koleksiyonun
    // JSON'unu döndürüyor; bu yüzden kök adres ve varsayılan Accept kullanılır.
    var u = root() + '?sections=' + SECTION_ID;
    return this._fetch(u, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (json) { return json && json[SECTION_ID]; })
      .catch(function () { return null; });
  };

  /* Sepeti ve çekmece HTML'ini birlikte tazeler */
  P._refresh = function () {
    var self = this;
    this.state.isLoading = true;
    return Promise.all([this._getCart(), this._getSection()])
      .then(function (r) {
        self._setCart(r[0]);
        if (r[1]) self._renderSection(r[1]);
        self._dirty = false;
        return r[0];
      })
      .catch(function (err) {
        self.notifyObservers('cart:error', err);
        throw err;
      })
      .then(function (cart) { self.state.isLoading = false; return cart; },
        function (err) { self.state.isLoading = false; throw err; });
  };

  /* change.js / update.js cevabı: sepet + bölüm HTML'i aynı anda gelir */
  P._applyResponse = function (data) {
    if (!data) return this._refresh();
    var html = data.sections && data.sections[SECTION_ID];
    if (data.items && typeof data.item_count === 'number') {
      this._setCart(data);
      if (html) {
        this._renderSection(html);
        this._dirty = false;
        return Promise.resolve(data);
      }
    }
    return this._refresh();
  };

  P._setCart = function (cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    this.state.cart = cart;
    this.state.lastUpdate = Date.now();
    this.notifyObservers('cart:fetched', cart);
    this.notifyObservers('cart:count-updated', { count: cart.item_count });
    this._checkGift(cart);
  };

  /* ───────────── hediye ürün ───────────── */

  P._giftCfg = function () {
    var g = window.FT_GIFT;
    return g && g.on && g.variant && g.threshold > 0 ? g : null;
  };
  P._isGift = function (item) {
    return !!(item && item.properties && item.properties[GIFT_PROP]);
  };

  /* Sepete göre yapılması gereken: null (her şey yerinde) ya da { updates: {key: adet}, add: true|false } */
  P._giftPlan = function (cart) {
    var cfg = this._giftCfg();
    var items = (cart && cart.items) || [];
    var gifts = [];
    var base = 0;
    var others = 0, giftFinal = 0;
    for (var i = 0; i < items.length; i++) {
      if (this._isGift(items[i])) { gifts.push(items[i]); giftFinal += items[i].final_line_price || 0; }
      else {
        base += items[i].final_line_price || 0;
        others += items[i].quantity || 0;
      }
    }
    var cartDisc = 0, apps = (cart && cart.cart_level_discount_applications) || []; for (var j = 0; j < apps.length; j++) cartDisc += apps[j].total_allocated_amount || 0; if (cartDisc > 0 && base + giftFinal > 0) cartDisc = Math.round(cartDisc * base / (base + giftFinal)); /* 18.10.2026: esik NET tutara gore, sepete tanimli indirim kodu (or. FLATTER30) dusulur */ var want = !!cfg && !this._giftBlocked && others > 0 && base - cartDisc >= cfg.threshold;
    var updates = {};
    var changed = false;
    var add = false;
    if (!want) {
      gifts.forEach(function (g) { updates[g.key] = 0; changed = true; });
    } else if (!gifts.length) {
      add = true;
    } else {
      gifts.forEach(function (g, n) {
        var q = n === 0 && g.variant_id === cfg.variant ? 1 : 0;
        if (g.quantity !== q) { updates[g.key] = q; changed = true; }
      });
      if (gifts[0].variant_id !== cfg.variant) add = true; // hediye ürün değişti: eskisi çıkar, yenisi gelir
    }
    if (!changed && !add) return null;
    return { updates: changed ? updates : null, add: add };
  };

  P._checkGift = function (cart) {
    if (this._giftSyncing) return;
    if (!this._giftPlan(cart)) { this._giftRounds = 0; return; }
    if (++this._giftRounds > 4) return; // döngü koruması
    this._giftSyncing = true;
    var self = this;
    this._enqueue(function () {
      // sırası gelince güncel sepete göre yeniden hesapla (arada başka değişiklik olmuş olabilir)
      return self._getCart().then(function (fresh) {
        var plan = self._giftPlan(fresh);
        if (!plan) { self.state.cart = fresh; return null; }
        var cfg = self._giftCfg();
        var step = Promise.resolve();
        if (plan.updates) {
          step = step.then(function () { return self._post('cart/update.js', { updates: plan.updates }, false); })
            .then(function () { if (!plan.add) self.notifyObservers('cart:gift-removed', {}); });
        }
        if (plan.add && cfg) {
          var props = {};
          props[GIFT_PROP] = '1';
          if (cfg.label) props.Hediye = cfg.label;
          step = step.then(function () {
            return self._post('cart/add.js', { items: [{ id: cfg.variant, quantity: 1, properties: props }] }, false);
          }).then(function () {
            self.notifyObservers('cart:gift-added', { variant: cfg.variant });
            if (window.v4Track) window.v4Track('cart_gift_added', { variant: String(cfg.variant) });
          }, function (err) {
            self._giftBlocked = true; // stokta yok vb.: bu sayfada tekrar deneme
            throw err;
          });
        }
        return step.then(function () { return self._refresh(); });
      });
    }).catch(function () {
      return self._enqueue(function () { return self._refresh(); }).catch(function () {});
    }).then(function () {
      self._giftSyncing = false;
      if (self.state.cart) self._checkGift(self.state.cart);
    });
  };

  /* ───────────── çizim ───────────── */

  P._renderSection = function (html) {
    if (!this.elements.drawer) this._bindElements();
    var drawer = this.elements.drawer;
    if (!drawer || !html) return;
    var tpl = document.createElement('div');
    tpl.innerHTML = html;
    var fresh = tpl.querySelector('#CartDrawer');
    if (!fresh) return;

    var body = drawer.querySelector('#CartDrawerBody');
    var scroll = body ? body.scrollTop : 0;
    ['.cart-drawer__header', '#CartDrawerBody', '.cart-drawer__footer'].forEach(function (sel) {
      var a = drawer.querySelector(sel);
      var b = fresh.querySelector(sel);
      if (a && b && a.innerHTML !== b.innerHTML) a.innerHTML = b.innerHTML;
    });
    this._bindElements();
    if (this.elements.body) this.elements.body.scrollTop = scroll;

    // Henüz gönderilmemiş adet değişikliklerini yeni çizimde koru
    var self = this;
    Object.keys(this._pendingQty).forEach(function (key) {
      var input = self._input(key);
      if (input) {
        input.value = self._pendingQty[key];
        input.classList.add('updating');
      }
    });
    this._syncCheckout();
  };

  P._syncCheckout = function () {
    var btn = this.elements.drawer && this.elements.drawer.querySelector('[data-checkout-button]');
    if (!btn) return;
    var empty = !this.state.cart || this.state.cart.item_count === 0;
    btn.classList.toggle('disabled', empty);
    btn.setAttribute('aria-disabled', empty ? 'true' : 'false');
  };

  P._showError = function (message) {
    var drawer = this.elements.drawer;
    if (!drawer) return;
    var box = drawer.querySelector('[data-cart-error]');
    if (!box) {
      box = document.createElement('div');
      box.className = 'cart-drawer__error';
      box.setAttribute('data-cart-error', '');
      box.setAttribute('role', 'alert');
      var body = drawer.querySelector('#CartDrawerBody');
      if (body) body.parentNode.insertBefore(box, body);
      else drawer.appendChild(box);
    }
    box.textContent = message;
    box.hidden = false;
    clearTimeout(this._errTimer);
    this._errTimer = setTimeout(function () { box.hidden = true; }, 5000);
  };

  /* ───────────── satır yardımcıları ───────────── */

  P._esc = function (s) {
    return window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/"/g, '\\"');
  };
  P._item = function (key) {
    return this.elements.drawer && this.elements.drawer.querySelector('.cart-drawer__item[data-key="' + this._esc(key) + '"]');
  };
  P._input = function (key) {
    var li = this._item(key);
    return li && li.querySelector('[data-qty-input]');
  };
  /* Düğmeden satır anahtarı: data-key; yoksa (eski işaretleme) data-line → anahtar */
  P._keyFrom = function (el) {
    var holder = el.closest('[data-key]');
    if (holder) return holder.getAttribute('data-key');
    var line = parseInt(el.getAttribute('data-line'), 10);
    var item = this.state.cart && this.state.cart.items[line - 1];
    return item ? item.key : null;
  };
  P._cartItem = function (key) {
    var items = (this.state.cart && this.state.cart.items) || [];
    for (var i = 0; i < items.length; i++) if (items[i].key === key) return items[i];
    return null;
  };

  /* ───────────── olaylar ───────────── */

  P._onClick = function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-open-cart]')) {
      e.preventDefault();
      this.openDrawer();
      return;
    }
    if (t.closest('[data-cart-drawer-close]') || t.closest('#CartDrawerOverlay')) {
      e.preventDefault();
      this.closeDrawer();
      return;
    }
    if (!this.elements.drawer || !this.elements.drawer.contains(t)) return;

    var remove = t.closest('[data-qty-remove]');
    var plus = t.closest('[data-qty-increase]');
    var minus = t.closest('[data-qty-decrease]');
    var upgrade = t.closest('[data-cart-upgrade]');

    if (remove || plus || minus) {
      e.preventDefault();
      var btn = remove || plus || minus;
      var key = this._keyFrom(btn);
      if (!key || this._isGift(this._cartItem(key))) return;
      if (remove) return this._remove(key);
      var input = this._input(key);
      var current = parseInt(input && input.value, 10);
      if (isNaN(current)) current = (this._cartItem(key) || {}).quantity || 1;
      this._setQty(key, Math.max(0, current + (plus ? 1 : -1)));
      return;
    }
    if (upgrade) {
      e.preventDefault();
      this._upgrade(upgrade);
    }
  };

  P._onChange = function (e) {
    var input = e.target && e.target.closest && e.target.closest('[data-qty-input]');
    if (!input || !this.elements.drawer || !this.elements.drawer.contains(input)) return;
    var key = this._keyFrom(input);
    var qty = parseInt(input.value, 10);
    if (!key || isNaN(qty) || qty < 0) return;
    this._setQty(key, Math.min(qty, 99), true);
  };

  P._onKeydown = function (e) {
    if (e.key === 'Escape' && this.elements.drawer && this.elements.drawer.getAttribute('aria-hidden') === 'false') {
      this.closeDrawer();
      return;
    }
    if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('[data-qty-input]')) {
      e.preventDefault();
      e.target.blur();
    }
  };

  P._onSubmit = function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = String(form.getAttribute('action') || '');
    if (!/\/cart\/add(\.js)?/i.test(action) && !form.hasAttribute('data-ajax-add')) return;
    e.preventDefault();
    var submit = form.querySelector('[type=submit]');
    if (submit) submit.setAttribute('aria-busy', 'true');
    this.addToCart(new FormData(form))
      .catch(function () {})
      .then(function () { if (submit) submit.removeAttribute('aria-busy'); });
  };

  /* ───────────── işlemler ───────────── */

  /* Adet: art arda tıklamalar birikir, son değer tek istekle gider */
  P._setQty = function (key, qty, immediate) {
    var self = this;
    var item = this._cartItem(key);
    var original = item ? item.quantity : null;
    this._pendingQty[key] = qty;
    var input = this._input(key);
    if (input) {
      input.value = qty;
      input.classList.add('updating');
    }
    if (original !== null) {
      var count = this.state.cart.item_count - original + qty;
      this.notifyObservers('cart:count-updated', { count: count });
      var countEl = this.elements.drawer && this.elements.drawer.querySelector('.cart-drawer__count');
      if (countEl) countEl.textContent = '(' + count + ')';
    }
    if (qty === 0) {
      var li = this._item(key);
      if (li) li.classList.add('is-removing');
    }
    clearTimeout(this._qtyTimers[key]);
    this._qtyTimers[key] = setTimeout(function () {
      delete self._qtyTimers[key];
      self._commitQty(key);
    }, immediate || qty === 0 ? 0 : QTY_DEBOUNCE);
  };

  P._remove = function (key) {
    var btn = this._item(key) && this._item(key).querySelector('[data-qty-remove]');
    if (btn) btn.classList.add('updating');
    this._setQty(key, 0, true);
  };

  P._commitQty = function (key) {
    var self = this;
    return this._enqueue(function () {
      if (!(key in self._pendingQty)) return null;
      var qty = self._pendingQty[key];
      delete self._pendingQty[key];
      if (!self._cartItem(key)) {
        // satır zaten yok (başka sekmede silinmiş ya da yükseltmeyle değişmiş): sadece tazele
        return self._refresh();
      }
      return self._post('cart/change.js', { id: key, quantity: qty }, true)
        .then(function (data) { return self._applyResponse(data); })
        .then(function (cart) {
          self.notifyObservers('cart:quantity-changed', { key: key, quantity: qty });
          return cart;
        })
        .catch(function (err) {
          self._showError(err && err.status === 422 && err.message ? err.message : 'Sepet güncellenemedi, lütfen tekrar deneyin.');
          self.notifyObservers('cart:error', err);
          return self._refresh().catch(function () {});
        });
    });
  };

  /* Eski imza: changeQuantity(line, qty) — sayı satır numarası, metin satır anahtarı */
  P.changeQuantity = function (lineOrKey, quantity) {
    var key = lineOrKey;
    if (typeof lineOrKey === 'number') {
      var item = this.state.cart && this.state.cart.items[lineOrKey - 1];
      key = item && item.key;
    }
    if (!key || typeof quantity !== 'number' || quantity < 0) return Promise.reject(new Error('Invalid quantity parameters'));
    this._pendingQty[key] = quantity;
    return this._commitQty(key);
  };

  /* FormData (ürün formu) ya da [{id, quantity, properties}] */
  P.addToCart = function (payload, options) {
    var self = this;
    options = options || {};
    var items;
    if (payload instanceof FormData) {
      var props = {};
      var id = payload.get('id');
      var qty = parseInt(payload.get('quantity') || '1', 10) || 1;
      payload.forEach(function (v, k) {
        var m = /^properties\[(.+)\]$/.exec(k);
        if (m && v !== '') props[m[1]] = v;
      });
      items = [{ id: parseInt(id, 10), quantity: qty, properties: props }];
    } else {
      items = Array.isArray(payload) ? payload : [payload];
    }
    this.state.isAdding = true;
    return this._enqueue(function () {
      return self._post('cart/add.js', { items: items }, true)
        .then(function (data) {
          var html = data && data.sections && data.sections[SECTION_ID];
          return self._getCart().then(function (cart) {
            self._setCart(cart);
            if (html) { self._renderSection(html); self._dirty = false; } else return self._refresh();
            return cart;
          });
        });
    }).then(function (cart) {
      self.state.isAdding = false;
      if (options.open !== false) self.openDrawer();
      self.notifyObservers('cart:item-added', { items: items });
      return cart;
    }, function (err) {
      self.state.isAdding = false;
      if (options.open !== false) self.openDrawer();
      self._showError(err && err.message ? err.message : 'Ürün sepete eklenemedi.');
      self.notifyObservers('cart:error', err);
      throw err;
    });
  };

  /* Sepet yükseltme: data-to-variant (eklenecek paket), data-from ("key*adet,key*adet": paketin yerine geçtiği
     satırlar), data-label (siparişte görünen not). Önce paket eklenir, sonra eski ürünler düşülür. */
  P._upgrade = function (btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var self = this;
    var toId = parseInt(btn.getAttribute('data-to-variant'), 10);
    var label = btn.getAttribute('data-label') || '';
    var from = (btn.getAttribute('data-from') || '').split(',').filter(Boolean).map(function (part) {
      var bits = part.split('*');
      return { key: bits[0], take: parseInt(bits[1] || '1', 10) || 1 };
    });
    if (!toId || !from.length) return;

    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    var card = btn.closest('[data-upgrade-card]');
    if (card) card.classList.add('is-loading');

    this._enqueue(function () {
      // satırları tıklama anında güncel sepetten çöz (kart çizildikten sonra sepet değişmiş olabilir)
      return self._getCart().then(function (cart) {
        self._setCart(cart);
        var updates = {};
        for (var i = 0; i < from.length; i++) {
          var item = self._cartItem(from[i].key);
          if (!item || item.quantity < from[i].take) {
            var stale = new Error('stale');
            stale.stale = true;
            throw stale;
          }
          updates[from[i].key] = item.quantity - from[i].take;
        }
        var log = (cart.attributes && cart.attributes[UPGRADE_ATTR]) || '';
        log = log ? log + ' | ' + label : label;
        var attrs = {};
        attrs[UPGRADE_ATTR] = log;
        return self._post('cart/add.js', { items: [{ id: toId, quantity: 1, properties: { _cart_upgrade: label } }] }, false)
          .then(function () {
            return self._post('cart/update.js', { updates: updates, attributes: attrs }, true);
          })
          .then(function (data) { return self._applyResponse(data); });
      });
    }).then(function (cart) {
      self.notifyObservers('cart:upgraded', { to: toId, label: label });
      if (window.v4Track) window.v4Track('cart_upgrade', { to_variant: String(toId), label: label });
      return cart;
    }).catch(function (err) {
      if (!err || !err.stale) self._showError(err && err.status === 422 && err.message ? err.message : 'Yükseltme yapılamadı, lütfen tekrar deneyin.');
      return self._enqueue(function () { return self._refresh(); }).catch(function () {});
    }).then(function () {
      btn.removeAttribute('aria-busy');
      btn.classList.remove('is-loading');
      if (card) card.classList.remove('is-loading');
    });
  };

  P.clearCart = function () {
    var self = this;
    return this._enqueue(function () {
      return self._post('cart/clear.js', {}, true).then(function (data) { return self._applyResponse(data); });
    }).then(function (cart) { self.notifyObservers('cart:cleared'); return cart; });
  };

  P.updateCartNote = function (note) {
    var self = this;
    return this._enqueue(function () {
      return self._post('cart/update.js', { note: note }, true).then(function (data) { return self._applyResponse(data); });
    });
  };

  /* fetchCart(force): sepeti ve çekmeceyi tazeler. force olmadan, sepet son 2 sn içinde tazelendiyse mevcut sepeti döner. */
  P.fetchCart = function (force) {
    var self = this;
    if (!force && this.state.cart && !this._dirty && Date.now() - this.state.lastUpdate < 2000) {
      return Promise.resolve(this.state.cart);
    }
    if (this._externalTimer) { clearTimeout(this._externalTimer); this._externalTimer = null; }
    return this._enqueue(function () { return self._refresh(); });
  };
  P.refresh = function () { return this.fetchCart(true); };
  P.manualRefresh = function () { return this.fetchCart(true); };

  /* ───────────── çekmece ───────────── */

  P.openDrawer = function () {
    if (!this.elements.drawer) this._bindElements();
    var drawer = this.elements.drawer;
    var overlay = this.elements.overlay;
    if (!drawer || !overlay) return;
    clearTimeout(this._overlayTimer);
    overlay.removeAttribute('hidden');
    void overlay.offsetHeight;
    document.documentElement.classList.add('cart-drawer-open');
    document.body.classList.add('cart-drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (this._dirty || Date.now() - this.state.lastUpdate > 30000) this.fetchCart(true).catch(function () {});
    this.notifyObservers('cart:drawer-opened');
  };

  P.closeDrawer = function () {
    var drawer = this.elements.drawer;
    var overlay = this.elements.overlay;
    if (!drawer || !overlay) return;
    document.documentElement.classList.remove('cart-drawer-open');
    document.body.classList.remove('cart-drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
    this._overlayTimer = setTimeout(function () { overlay.setAttribute('hidden', ''); }, 300);
    // bekleyen adet değişikliklerini kaybetme: hemen gönder
    var self = this;
    Object.keys(this._qtyTimers).forEach(function (key) {
      clearTimeout(self._qtyTimers[key]);
      delete self._qtyTimers[key];
      self._commitQty(key);
    });
    this.notifyObservers('cart:drawer-closed');
  };

  /* ───────────── yardımcılar / uyumluluk ───────────── */

  P.formatMoney = function (cents) {
    if (window.v4FormatMoney) return window.v4FormatMoney(cents);
    return (cents / 100).toFixed(2) + ' TL';
  };
  P.addObserver = function (cb) {
    var set = this.state.observers;
    set.add(cb);
    return function () { set.delete(cb); };
  };
  P.removeObserver = function (cb) { this.state.observers.delete(cb); };
  P.notifyObservers = function (event, data) {
    if (data === undefined) data = null;
    this.state.observers.forEach(function (cb) {
      try { cb(event, data); } catch (e) { if (window.console) console.error('Observer callback error:', e); }
    });
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  };
  P.getCart = function () { return this.state.cart; };
  P.getItemCount = function () { return (this.state.cart && this.state.cart.item_count) || 0; };
  P.getTotalPrice = function () { return (this.state.cart && this.state.cart.total_price) || 0; };
  P.isEmpty = function () { return !this.state.cart || this.state.cart.item_count === 0; };
  P.isLoading = function () { return this.state.isLoading; };
  P.isInitialized = function () { return this.state.isInitialized; };

  window.CartManager = new Manager();
})();
